import React, { useRef } from 'react';

const formatCount = (count) => (typeof count === 'number' ? count.toLocaleString('en-US') : count);

// tabs: [{ id, label, count? }]. Pair each tab with a <TabPanel> using the same id and idPrefix.
export default function Tabs({ tabs, value, onChange, label, idPrefix = 'tabs', className = '' }) {
  const listRef = useRef(null);

  const onKeyDown = (event) => {
    const index = tabs.findIndex((tab) => tab.id === value);
    const moves = { ArrowRight: index + 1, ArrowLeft: index - 1, Home: 0, End: tabs.length - 1 };
    if (!(event.key in moves)) return;
    event.preventDefault();
    const next = tabs[(moves[event.key] + tabs.length) % tabs.length];
    onChange(next.id);
    listRef.current.querySelector(`#${idPrefix}-tab-${next.id}`)?.focus();
  };

  return (
    <div
      ref={listRef}
      role="tablist"
      aria-label={label}
      onKeyDown={onKeyDown}
      className={`shrink-0 flex gap-0.5 border-b border-rule ${className}`}
    >
      {tabs.map((tab) => {
        const selected = tab.id === value;
        return (
          <button
            key={tab.id}
            id={`${idPrefix}-tab-${tab.id}`}
            type="button"
            role="tab"
            aria-selected={selected}
            aria-controls={`${idPrefix}-panel-${tab.id}`}
            tabIndex={selected ? 0 : -1}
            onClick={() => onChange(tab.id)}
            className={[
              '-mb-px flex items-center h-9 px-3 border-b-2 text-body whitespace-nowrap',
              selected ? 'border-signal text-ink font-semibold' : 'border-transparent text-graphite hover:text-ink',
            ].join(' ')}
          >
            {tab.label}
            {tab.count !== undefined && tab.count !== null && (
              <span className="ml-1.5 font-mono text-small font-normal text-graphite">{formatCount(tab.count)}</span>
            )}
          </button>
        );
      })}
    </div>
  );
}

export function TabPanel({ id, idPrefix = 'tabs', className = '', children }) {
  return (
    <div role="tabpanel" id={`${idPrefix}-panel-${id}`} aria-labelledby={`${idPrefix}-tab-${id}`} className={className}>
      {children}
    </div>
  );
}
